/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addOrder_1 } from '../fn/order-v-2/add-order-1';
import { AddOrder_1$Params } from '../fn/order-v-2/add-order-1';
import { createSplitBill } from '../fn/order-v-2/create-split-bill';
import { CreateSplitBill$Params } from '../fn/order-v-2/create-split-bill';
import { SuccessfulActionResponse as DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse } from '../models/Digiwork/MaitreD/Api/Configuration/Model/CustomResponses/successful-action-response';
import { SuccessfulResponse as DigiworkMaitreDApiConfigurationModelSuccessfulResponse } from '../models/Digiwork/MaitreD/Api/Configuration/Model/successful-response';
import { BillDetailsDto as DigiworkMaitreDPosDtoBillsBillDetailsDto } from '../models/Digiwork/MaitreD/Pos/DTO/Bills/bill-details-dto';
import { BillsDto as DigiworkMaitreDPosDtoBillsBillsDto } from '../models/Digiwork/MaitreD/Pos/DTO/Bills/bills-dto';
import { BillsSummarizedDto as DigiworkMaitreDPosDtoBillsBillsSummarizedDto } from '../models/Digiwork/MaitreD/Pos/DTO/Bills/bills-summarized-dto';
import { PaginatedBillDtOs as DigiworkMaitreDPosDtoBillsPaginatedBillDtOs } from '../models/Digiwork/MaitreD/Pos/DTO/Bills/paginated-bill-dt-os';
import { OrderDetailsDto as DigiworkMaitreDPosDtoOrderV2OrderDetailsDto } from '../models/Digiwork/MaitreD/Pos/DTO/OrderV2/order-details-dto';
import { OrdersDto as DigiworkMaitreDPosDtoOrderV2OrdersDto } from '../models/Digiwork/MaitreD/Pos/DTO/OrderV2/orders-dto';
import { OrdersForPrintDto as DigiworkMaitreDPosDtoOrderV2OrdersForPrintDto } from '../models/Digiwork/MaitreD/Pos/DTO/OrderV2/orders-for-print-dto';
import { PaginatedOrderDtOs as DigiworkMaitreDPosDtoOrderV2PaginatedOrderDtOs } from '../models/Digiwork/MaitreD/Pos/DTO/OrderV2/paginated-order-dt-os';
import { getBill } from '../fn/order-v-2/get-bill';
import { GetBill$Params } from '../fn/order-v-2/get-bill';
import { getBillsForManagerSummarized } from '../fn/order-v-2/get-bills-for-manager-summarized';
import { GetBillsForManagerSummarized$Params } from '../fn/order-v-2/get-bills-for-manager-summarized';
import { getBillsForTable } from '../fn/order-v-2/get-bills-for-table';
import { GetBillsForTable$Params } from '../fn/order-v-2/get-bills-for-table';
import { getFilteredBillsPaginated } from '../fn/order-v-2/get-filtered-bills-paginated';
import { GetFilteredBillsPaginated$Params } from '../fn/order-v-2/get-filtered-bills-paginated';
import { getFilteredOrdersPaginated } from '../fn/order-v-2/get-filtered-orders-paginated';
import { GetFilteredOrdersPaginated$Params } from '../fn/order-v-2/get-filtered-orders-paginated';
import { getOrder } from '../fn/order-v-2/get-order';
import { GetOrder$Params } from '../fn/order-v-2/get-order';
import { getOrderForPrint } from '../fn/order-v-2/get-order-for-print';
import { GetOrderForPrint$Params } from '../fn/order-v-2/get-order-for-print';
import { getOrders } from '../fn/order-v-2/get-orders';
import { GetOrders$Params } from '../fn/order-v-2/get-orders';
import { payBill } from '../fn/order-v-2/pay-bill';
import { PayBill$Params } from '../fn/order-v-2/pay-bill';
import { printBill } from '../fn/order-v-2/print-bill';
import { PrintBill$Params } from '../fn/order-v-2/print-bill';
import { removeOrderLineItems } from '../fn/order-v-2/remove-order-line-items';
import { RemoveOrderLineItems$Params } from '../fn/order-v-2/remove-order-line-items';
import { removeSplitBill } from '../fn/order-v-2/remove-split-bill';
import { RemoveSplitBill$Params } from '../fn/order-v-2/remove-split-bill';

@Injectable({ providedIn: 'root' })
export class OrderV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getOrders()` */
  static readonly GetOrdersPath = '/api/orders';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrders()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrders$Response(params?: GetOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoOrderV2OrdersDto>> {
    return getOrders(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOrders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrders(params?: GetOrders$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoOrderV2OrdersDto> {
    return this.getOrders$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoOrderV2OrdersDto>): DigiworkMaitreDPosDtoOrderV2OrdersDto => r.body)
    );
  }

  /** Path part for operation `addOrder_1()` */
  static readonly AddOrder_1Path = '/api/orders';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addOrder_1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addOrder_1$Response(params?: AddOrder_1$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>> {
    return addOrder_1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addOrder_1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addOrder_1(params?: AddOrder_1$Params, context?: HttpContext): Observable<DigiworkMaitreDApiConfigurationModelSuccessfulResponse> {
    return this.addOrder_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>): DigiworkMaitreDApiConfigurationModelSuccessfulResponse => r.body)
    );
  }

  /** Path part for operation `getBillsForTable()` */
  static readonly GetBillsForTablePath = '/api/orders/bills';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBillsForTable()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBillsForTable$Response(params?: GetBillsForTable$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoBillsBillsDto>> {
    return getBillsForTable(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBillsForTable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBillsForTable(params?: GetBillsForTable$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoBillsBillsDto> {
    return this.getBillsForTable$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoBillsBillsDto>): DigiworkMaitreDPosDtoBillsBillsDto => r.body)
    );
  }

  /** Path part for operation `createSplitBill()` */
  static readonly CreateSplitBillPath = '/api/orders/bills/{billId}/split-bill';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSplitBill()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSplitBill$Response(params: CreateSplitBill$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>> {
    return createSplitBill(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSplitBill$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSplitBill(params: CreateSplitBill$Params, context?: HttpContext): Observable<DigiworkMaitreDApiConfigurationModelSuccessfulResponse> {
    return this.createSplitBill$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>): DigiworkMaitreDApiConfigurationModelSuccessfulResponse => r.body)
    );
  }

  /** Path part for operation `removeSplitBill()` */
  static readonly RemoveSplitBillPath = '/api/orders/bills/{billId}/split-bill';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeSplitBill()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeSplitBill$Response(params: RemoveSplitBill$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse>> {
    return removeSplitBill(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeSplitBill$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeSplitBill(params: RemoveSplitBill$Params, context?: HttpContext): Observable<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse> {
    return this.removeSplitBill$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse>): DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse => r.body)
    );
  }

  /** Path part for operation `payBill()` */
  static readonly PayBillPath = '/api/orders/bills/{billId}/pay-bill';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `payBill()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  payBill$Response(params: PayBill$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse>> {
    return payBill(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `payBill$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  payBill(params: PayBill$Params, context?: HttpContext): Observable<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse> {
    return this.payBill$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse>): DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse => r.body)
    );
  }

  /** Path part for operation `printBill()` */
  static readonly PrintBillPath = '/api/orders/bills/{billId}/print-bill';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `printBill()` instead.
   *
   * This method doesn't expect any request body.
   */
  printBill$Response(params: PrintBill$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse>> {
    return printBill(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `printBill$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  printBill(params: PrintBill$Params, context?: HttpContext): Observable<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse> {
    return this.printBill$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse>): DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse => r.body)
    );
  }

  /** Path part for operation `getOrder()` */
  static readonly GetOrderPath = '/api/orders/{orderId}/details';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrder$Response(params: GetOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoOrderV2OrderDetailsDto>> {
    return getOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrder(params: GetOrder$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoOrderV2OrderDetailsDto> {
    return this.getOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoOrderV2OrderDetailsDto>): DigiworkMaitreDPosDtoOrderV2OrderDetailsDto => r.body)
    );
  }

  /** Path part for operation `getBill()` */
  static readonly GetBillPath = '/api/orders/bills/{billId}/details';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBill()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBill$Response(params: GetBill$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoBillsBillDetailsDto>> {
    return getBill(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBill$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBill(params: GetBill$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoBillsBillDetailsDto> {
    return this.getBill$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoBillsBillDetailsDto>): DigiworkMaitreDPosDtoBillsBillDetailsDto => r.body)
    );
  }

  /** Path part for operation `removeOrderLineItems()` */
  static readonly RemoveOrderLineItemsPath = '/api/orders/bills/{billId}/order-line-items';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeOrderLineItems()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeOrderLineItems$Response(params: RemoveOrderLineItems$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse>> {
    return removeOrderLineItems(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeOrderLineItems$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeOrderLineItems(params: RemoveOrderLineItems$Params, context?: HttpContext): Observable<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse> {
    return this.removeOrderLineItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse>): DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse => r.body)
    );
  }

  /** Path part for operation `getOrderForPrint()` */
  static readonly GetOrderForPrintPath = '/api/orders/{orderId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrderForPrint()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrderForPrint$Response(params: GetOrderForPrint$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoOrderV2OrdersForPrintDto>> {
    return getOrderForPrint(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOrderForPrint$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrderForPrint(params: GetOrderForPrint$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoOrderV2OrdersForPrintDto> {
    return this.getOrderForPrint$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoOrderV2OrdersForPrintDto>): DigiworkMaitreDPosDtoOrderV2OrdersForPrintDto => r.body)
    );
  }

  /** Path part for operation `getFilteredOrdersPaginated()` */
  static readonly GetFilteredOrdersPaginatedPath = '/api/orders/get-orders-paginated';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFilteredOrdersPaginated()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getFilteredOrdersPaginated$Response(params?: GetFilteredOrdersPaginated$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoOrderV2PaginatedOrderDtOs>> {
    return getFilteredOrdersPaginated(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFilteredOrdersPaginated$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getFilteredOrdersPaginated(params?: GetFilteredOrdersPaginated$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoOrderV2PaginatedOrderDtOs> {
    return this.getFilteredOrdersPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoOrderV2PaginatedOrderDtOs>): DigiworkMaitreDPosDtoOrderV2PaginatedOrderDtOs => r.body)
    );
  }

  /** Path part for operation `getFilteredBillsPaginated()` */
  static readonly GetFilteredBillsPaginatedPath = '/api/orders/bills/get-bills-paginated';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFilteredBillsPaginated()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getFilteredBillsPaginated$Response(params?: GetFilteredBillsPaginated$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoBillsPaginatedBillDtOs>> {
    return getFilteredBillsPaginated(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFilteredBillsPaginated$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getFilteredBillsPaginated(params?: GetFilteredBillsPaginated$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoBillsPaginatedBillDtOs> {
    return this.getFilteredBillsPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoBillsPaginatedBillDtOs>): DigiworkMaitreDPosDtoBillsPaginatedBillDtOs => r.body)
    );
  }

  /** Path part for operation `getBillsForManagerSummarized()` */
  static readonly GetBillsForManagerSummarizedPath = '/api/orders/bills/paginated/summarized';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBillsForManagerSummarized()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getBillsForManagerSummarized$Response(params?: GetBillsForManagerSummarized$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoBillsBillsSummarizedDto>> {
    return getBillsForManagerSummarized(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBillsForManagerSummarized$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getBillsForManagerSummarized(params?: GetBillsForManagerSummarized$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoBillsBillsSummarizedDto> {
    return this.getBillsForManagerSummarized$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoBillsBillsSummarizedDto>): DigiworkMaitreDPosDtoBillsBillsSummarizedDto => r.body)
    );
  }

}
